import { z } from 'zod';
import { CHAT_MESSAGE_FEEDBACK_VALUES, ChatMessageIdSchema, ChatMessageUserFeedbackSchema, MAX_AI_FEEDBACK_COMMENT_LENGTH } from '../../shared/chat-message';
import { ObjectIdSchema } from '../../shared/object-id.schema';
/**
 * A vote on one assistant answer, or its retraction (`value: null` — pressing
 * the active thumb again).
 *
 * The client NEVER names a Langfuse trace: the service resolves the target
 * message through the caller-authorized session query and reads the trace id
 * off the stored row, so a vote can only ever reach a trace the caller was
 * already allowed to read.
 *
 * `comment` is the RAW textarea value rather than the union's canonical one: a
 * user who opens the comment box and sends it empty must get their standing
 * down-vote back, not a validation error, so blank is accepted here and trimmed
 * to absent by the service before it becomes stored state.
 */ export const SubmitAiFeedbackRequestSchema = z.object({
    sessionId: ObjectIdSchema,
    messageId: ChatMessageIdSchema,
    value: z.enum(CHAT_MESSAGE_FEEDBACK_VALUES).nullable(),
    comment: z.string().max(MAX_AI_FEEDBACK_COMMENT_LENGTH).optional()
}).refine((body)=>body.comment === undefined || body.value === 'down', {
    message: 'A comment may only accompany a thumbs-down',
    path: [
        'comment'
    ]
});
/**
 * The verdict Mongo holds once the write has settled — `null` once the vote is
 * retracted. It is what the request COMPUTED to, which is not always what it
 * sent: a blank comment is trimmed away, and a bare re-press keeps the comment
 * already stored. No client reconciles its widget from it (the optimistic state
 * stands until a remount refetches the history), so a concurrent vote on a
 * shared Bliksy recording is last-writer-wins.
 */ export const SubmitAiFeedbackResponseSchema = z.object({
    userFeedback: ChatMessageUserFeedbackSchema.nullable()
});

//# sourceMappingURL=submit-ai-feedback.schema.js.map